export default __webpack_public_path__ + "static/reward-product-pe-5bdcad78aa8d178ef583351f01d7710a.png";